import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  ListItem,
  ListItemText,
  List,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import SubmitButton from "../components/common/SubmitButton";
import Config from "../Config";
import IntroCard from "../components/Cards/IntroCard";
import LoadingDots from "../components/Lottie/LoadingDots";
import Backdrop from "../components/common/Backdrop";
import { useNavigate, useLocation } from "react-router-dom";
// import useRazorpay from "../utils/useRazorPay";
import userPluralPay from "../utils/usePluralPay";
import usePluralPay from "../utils/usePluralPay";
import IngenicoPaymentGateway from "../utils/IngenicoPaymentGateway";
import { loggerStore } from "../utils/utils";
import { apis } from "../services/apiService";
import styles from "../Style/Modules/pfPayment.module.css";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function PFPayment() {
  const [loading, setLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState();
  // const { razorPaycreateOrder, openRazorPay } = useRazorpay();
  const { pluralcreateOrder, openPlural } = usePluralPay();
  const [radioVal, setRadioVal] = useState("");
  const [eMsg, setEMsg] = useState("");
  const [finalErr, setFinalErr] = useState("");
  const [pfPaymentShow, setPFPaymentsShow] = useState("");
  const navigate = useNavigate();
  let location = useLocation();
  let IsLimitEnhacement_Reduction_PFpaymentSucc =
    location?.state?.IsLimitEnhacement_Reduction_PF;
  const { t } = useTranslation();
  let timer = 0;
  console.log("check location of amount---", location?.state?.Amt);
  console.log("check pfPaymentShow state---", pfPaymentShow);
  const { openIngenicoPayScreen } = IngenicoPaymentGateway();
  useEffect(() => {
    // console.log("Payment Status", paymentStatus);
    if (paymentStatus && Object?.keys(paymentStatus)?.length > 0) {
      let stateDataObj = {
        referenceno: paymentStatus?.reference_id || paymentStatus?.arNumber,
        amount: paymentStatus?.reference_id
          ? paymentStatus?.amount / 100
          : location?.state.Amt,
        paidamount: paymentStatus?.reference_id
          ? paymentStatus?.amount_paid / 100
          : location?.state.Amt,
        AppId: location?.state.AppId,
        IsLimitEnhacement_Reduction_Final_Check:
          IsLimitEnhacement_Reduction_PFpaymentSucc,
        Status: paymentStatus?.status !== "Paid" ? false : true,
        paymentstatus:
          paymentStatus?.status !== "Paid"
            ? "Payment Failed"
            : paymentStatus?.status,
      };
      if (paymentStatus?.status === "Paid") {
        stateDataObj.Amt = location.state.Amt;
        let navigateURL = "/PFPaymentSuccess";
        navigate(navigateURL, { state: { ...stateDataObj } });
      }

      // let navigateURL =
      //   paymentStatus?.status !== "Paid"
      //     ? "PaymentSuccess"
      //     : "/PFPaymentSuccess";

      // navigate(navigateURL, { state: { ...stateDataObj } });
    }
    // return () => {
    //   setPaymentStatus({});
    // };
  }, [paymentStatus?.status, eMsg]);

  // comman function for create and open api call
  // pluralPay integration start from here
  const callPluralpayAPI = async () => {
    let createOrderRes = await pluralcreateOrder(
      {
        aid: location.state.AppId,
        amount: location.state.Amt,
      },
      setLoading,
      Config.PFPayemntUrl + "PluralPayment/CreatePluralPaymentOrder",
      "PFPayment"
    );
    const createOrderResponse = {
      cOPluralOrderID: createOrderRes?.successResult?.plural_order_id,
      channelId: createOrderRes?.successResult?.channelId,
      paymentMode: createOrderRes?.successResult?.paymentMode,
      countryCode: createOrderRes?.successResult?.countryCode,
      emailId: createOrderRes?.successResult?.emailId,
      theme: createOrderRes?.successResult?.theme,
      showSavedCardsFeature:
        createOrderRes?.successResult?.showSavedCardsFeature,
      appID: location.state.AppId,
      mobileNumber: createOrderRes?.successResult?.mobileNumber,
      amount: location.state.Amt,
      orderToken: createOrderRes?.successResult?.token,
      arNumber: createOrderRes?.successResult?.arnumber,
      merchant_order_id: createOrderRes?.successResult?.merchant_order_id,
    };

    if (
      createOrderRes?.successResult !== null &&
      createOrderRes?.failedResult === null
    ) {
      await openPlural(
        createOrderResponse,
        setLoading,
        setPaymentStatus,
        setEMsg,
        "PFPayment",
        setRadioVal
      );
    } else if (createOrderRes?.failedResult?.plural_order_id) {
      await openPlural();
    } else {
      await openPlural();
    }
  };
  // PluralPay integration ended here

  // // razorPay integration start
  // const callrazorPayAPI = async () => {
  //   let createOrderRes = await razorPaycreateOrder(
  //     {
  //       aid: location.state.AppId,
  //       amt: location.state.Amt,
  //     },
  //     setLoading,
  //     Config.PFPayemntUrl + "ApplicationFlow/PFPayment",
  //     "PFPayment"
  //   );
  //   if (createOrderRes && Object.keys(createOrderRes).length > 0) {
  //     if ("isComp" in createOrderRes && createOrderRes?.isComp === true) {
  //       navigate("/BankDetails", { state: { AppId: location.state.AppId } });
  //     } else {
  //       await openRazorPay(
  //         createOrderRes,
  //         location.state.Amt,
  //         {
  //           aid: location.state.AppId,
  //           utr: "",
  //           amt: location.state.Amt,
  //           mno: createOrderRes.contact,
  //           cno: location.state.AppId,
  //         },
  //         createOrderRes?.contact,
  //         setLoading,
  //         setPaymentStatus,
  //         Config.PFPayemntUrl + "ApplicationFlow/PFPaymentStatus",
  //         "PFPayment",
  //         setEMsg,
  //         setRadioVal
  //       );
  //     }
  //   }
  // };
  // // razorPay integration ended

  // start Ingenico Payment request data
  useEffect(() => {
    //this effect call when ingenico payment is failed
    if (location?.state?.err) {
      setEMsg(location?.state?.err);
      setRadioVal("");
    }
  }, [location?.state?.err]);

  const getIngenicoPayDetail = async (e) => {
    // e.preventDefault();
    try {
      const reqData = {
        mno: location.state.mn,
        cno: location.state.AppId,
        amt: location.state.Amt,
        // em: location.state.em,
        em: "",
        type: "PF",
      };
      let resp = await apis.postApi(
        Config.API_URL + "PaymentMethod/GetIngenicoPaymentDetails",
        reqData
      );
      let result = await resp?.json();
      result.data.type = "PF";
      result.data.pfScreenData = { ...location.state };
      console.log("result on pf payment------", result);
      if (resp?.status === 200) {
        setLoading(false);
        setPFPaymentsShow(location?.state?.Amt);
        loggerStore(
          location?.state?.AppId,
          `Ingenico pfpayment successfully generated request data for PF = ${JSON?.stringify(
            result?.data
          )}`,
          "success"
        );
        return result?.data;
      }
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setLoading(false);
      loggerStore(
        location?.state?.AppId,
        `Ingenico pfpayment  facing issue while generating request data error for PF = ${JSON?.stringify(
          errorResult
        )}`,
        "error"
      );
      return false;
    }
  };
  // end Ingenico Payment request data

  const handleclick = async (event) => {
    event.preventDefault();
    var pstatus = "";
    if (loading === false) {
      setLoading(true);
      if (radioVal === "pluralPay") {
        await callPluralpayAPI();
      } else if (radioVal === "ingenicoPay") {
        const ingenicoPayDetail = await getIngenicoPayDetail();
        if (ingenicoPayDetail?.merchantId !== null || ingenicoPayDetail) {
          openIngenicoPayScreen(ingenicoPayDetail);
        } else {
          setFinalErr(
            "Their is an issue with payment gateway please try again after some time"
          );
        }
        // await openIngenicoPayScreen(await getIngenicoPayDetail());
      }
      //  else {
      //   openIngenicoPayScreen(ingenicoPayReqData);
      //   setLoading(false);
      // }
    }
  };

  // const handleclick = async (event) => {
  //   event.preventDefault();
  //   var pstatus = "";
  //   if (loading === false) {
  //     setLoading(true);
  //     await callrazorPayAPI();
  //   }
  // };

  const handleChange = (e) => {
    setEMsg("");
    setRadioVal(e.target.value);
  };

  useEffect(() => {
    // this is for remove error after refresh page while doing ingenico payment
    setEMsg("");
  }, []);
  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={9} />
        <IntroCard
          title="PF Payment"
          subtitle="Processing Fees"
          img="/assets/terms.svg"
        />
        <Box
          py={3}
          // py={5}
          className={styles.pFPaymentSuccessTypo}
        >
          <Box>
            {/* <Box sx={{ marginTop: "-50px" }}> */}
            <Typography
              variant="h1"
              sx={{ my: 2, textAlign: "center", color: "#1D1E24", mx: 5 }}
            >
              {t("Kindly do the payment of the PF Amount as mentioned below")}
            </Typography>
            <Typography
              color="info"
              sx={{
                textAlign: "center",
                color: "#0D1C6E",
                fontSize: "32px",
                fontWeight: "bold",
              }}
            >
              {t("₹")}
              {location?.state?.Amt
                ? location?.state?.Amt?.toString()?.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )
                : pfPaymentShow
                    ?.toString()
                    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </Typography>
          </Box>
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
        </Box>
        {eMsg && (
          <Box mt={0} ml={0} mb={2} textAlign={"center"}>
            <Typography
              variant="p"
              color="subtitle"
              sx={{ color: "red", textAlign: "center" }}
            >
              {eMsg}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            width: "100%",
            height: "100px",
            borderRadius: "10px",
            paddingBottom: "90px",
          }}
        >
          <Paper className={styles.pfPaymentPaper}>
            <Typography
              className="pfTxt_Th"
              // sx={{ color: "blue" }}
            >
              Please select the payment gateway
            </Typography>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={radioVal}
              onChange={handleChange}
              sx={{
                // backgroundColor: "red",
                m: "10px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box className={styles.pfPaymentBox}>
                <FormControlLabel
                  disabled
                  value="pluralPay"
                  control={<Radio />}
                  // label="Plural Pay"
                  label={
                    <p>
                      Plural Pay
                      <br />
                      (coming soon...)
                    </p>
                  }
                />
                {/* <Typography>Charges table</Typography> */}
                {/* <Typography>UPI Payment</Typography> */}
                {/* <Box className={styles.pfPaymentBox}> */}
              </Box>
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ backgroundColor: "black" }}
              />
              <Box className={styles.pfPaymentBox}>
                <FormControlLabel
                  ingenicoPay
                  // value="razorPay"
                  value="ingenicoPay"
                  control={<Radio />}
                  label="Ingenico Pay"
                />
                {/* <Typography>Charges table</Typography> */}
                {/* <Typography>UPI Payment</Typography> */}
              </Box>
            </RadioGroup>
          </Paper>
          <Box sx={{ paddingBottom: "100px" }}></Box>
        </Box>

        <form onSubmit={handleclick}>
          <SubmitButton hasNote="No" disabled={!radioVal} />{" "}
          {/*for plural andingenico integration*/}
          {/* <SubmitButton hasNote="No" /> */}
        </form>
      </Container>
    </>
  );
}
